import axios from '@/utils/request';

export const getInvoices = ({ company_id = 1, size = 10, page = 1, status = 0 }) =>
  axios.get(`v1/admin/invoice/all`, {
    params: { company_id, page, size, status },
  });

export const getInvoiceAvalible = (data) => axios.post(`v1/admin/invoice/avalible`, data);
export const getInvoiceHasInvoiced = (data) => axios.post(`v1/admin/invoice/hasInvoiced`, data);
export const createInvoices = (data) => axios.post(`v1/admin/invoice`, data);
export const v2createInvoices = (data) => axios.post(`v1/admin/invoice`, { ...data, version: 2 }, { timeout: 600000 });
export const importInvoices = (data, company_id = null) => axios.post(`v1/admin/invoice/import`, data, { params: { company_id } });
export const deleteInvoices = (data) => axios.post(`v1/admin/invoice/delete`, data);
export const getInvoice = (id) => axios.get(`v1/admin/invoice/one`, { params: { id } });
export const downloadExample = () => axios.post(`v1/admin/invoice/example`, null, { responseType: 'blob' });
